import axios from 'axios';
import { showError } from '../utils';
import config from '../config';

function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}
export function getAllMoods(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/mood-journal/allMoods`,
    headers,
  });
}
export function saveMoods(authToken, data) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/mood-journal/v2/save-user-moods`,
    headers,
    data,
  });
}

export function getPrimaryMoods(parentMoodId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/mood-journal/v2/primary-moods?parentMoodId=${parentMoodId}`,
    headers,
  });
}

export function getWeekMoods(moodLogId, authToken) {
  const headers = {
    authorization: authToken,
  };
  return axios
    .get(
      `${config.apiBaseUrl}/mood-journal/v2/week-moods?moodLogId=${moodLogId}`,
      {
        headers,
      }
    )
    .then((resp) => {
      const responseBody = resp.data.currentWeekMoodInsights;
      if (responseBody) {
        return resp.data;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      throw err;
    });
}

export function getMonthMoods(month, year, authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/mood-journal/v2/month-moods?month=${month}&year=${year}`,
    headers,
  });
}

export function getDayWiseMood(date, authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/mood-journal/v2/day-wise-mood?date=${date}`,
    headers,
  });
}
